import type { WorkOrderOtherActKc2PriceData, WorkOrderOtherPriceData, WorkOrderPriceItem } from 'gql/graphql';
import { WorkOrderStatusEnum, ActKc2StatusEnum } from 'gql/graphql';

export const checkActKC2OtherHaveNoZeroPrices = (row: WorkOrderOtherPriceData): boolean => {
    if (row?.isActKC2Price) {
        return !!(row?.actKC2Prices as (WorkOrderOtherActKc2PriceData & { actKC2status: ActKc2StatusEnum })[])?.reduce(
            (acc, item) => {
                if (
                    (item.actKC2status === ActKc2StatusEnum.InProgress && item.planCost) ||
                    (item.actKC2status === ActKc2StatusEnum.OnCheck && item.acceptedCost)
                ) {
                    acc = true;
                }

                return acc;
            },
            false,
        );
    }

    return false;
};

export const checkCanEditDistribution = (
    row: WorkOrderOtherPriceData | WorkOrderPriceItem | undefined | null,
    workOrderStatus: WorkOrderStatusEnum | undefined,
): boolean => {
    if (workOrderStatus === WorkOrderStatusEnum.OnFormation) {
        return true;
    }
    if (workOrderStatus === WorkOrderStatusEnum.InProgress && row) {
        if ('seasonPrices' in row) {
            return !row?.isActKC2Price && !!row?.seasonPrices?.every((price) => !price.completedCost);
        }

        if ('seasonValues' in row) {
            return !row?.isActKC2Price && !!row?.seasonValues?.every((price) => !price.completedCost);
        }

        return false;
    }

    return false;
};
